export const WEEKDAYS = [
  gettext('Понедельник'),
  gettext('Вторник'),
  gettext('Среда'),
  gettext('Четверг'),
  gettext('Пятница'),
  gettext('Суббота'),
  gettext('Воскресенье'),
];

export const ticksToHours = 36000000000;

export const ticksFormat = function (ticks) {
  let sec_num = Math.floor(ticks / 10000000);
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);
  let days = Math.floor(hours / 24);
  hours = hours - days * 24;
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  let time = (days ? days + gettext(' д ') : '') +
    hours + gettext(' ч ') +
    minutes + gettext(' м ') +
    seconds + gettext(' с');
  return time;
};

export const hoursToTime = function (hours) {
  let days = Math.floor(hours / 24);
  hours = hours % 24;
  if (hours < 10) {
    hours = '0' + hours;
  }
  let time = (days ? days + gettext(' д ') : '') +
    hours + gettext(' ч ');
  return time;
};

export const formatTimeSpan = (seconds) =>
  (isNaN(seconds) || !isFinite(seconds)) ? '?' :
    `${String(Math.floor(seconds / 60))}:${
      ('0' + String(Math.floor(seconds % 60))).slice(-2)}`;

export const formatCallDuration = (seconds) =>
  (isNaN(seconds) || !isFinite(seconds)) ? '?' :
    `${(seconds >= 36000 ? '' : '0') + String(Math.floor(seconds / 3600))}:\
${('0' + String(Math.floor(seconds / 60))).slice(-2)}:\
${('0' + String(seconds % 60)).slice(-2)}`;



// WEBPACK FOOTER //
// ./src/common/datetime.js